const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#63c3d1;}.b{fill:#fff;}"));
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 21,
  cy: 21,
  r: 21
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M29.2,17.873H19.384V8.055a.755.755,0,0,0-1.51,0v9.818H8.055a.755.755,0,0,0,0,1.51h9.818V29.2a.755.755,0,0,0,1.51,0V19.384H29.2a.755.755,0,0,0,0-1.51Z",
  transform: "translate(2.205 2.205)"
});
function SvgRediseo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRediseo);
export default __webpack_public_path__ + "static/media/rediseño.6f5dd51e9f504caaa90a191cc606e07f.svg";
export { ForwardRef as ReactComponent };